var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveAsImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "save-as-image_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-as-image_svg__ds",
    x1: 236.18,
    y1: 151.83,
    x2: 322.68,
    y2: 151.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-as-image_svg__dt",
    x1: 71.46,
    y1: 256.47,
    x2: 234.38,
    y2: 256.47,
    xlinkHref: "#save-as-image_svg__ds"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m322.23,145.58c-8.46-52.41-85.23-46.95-86.05,6.24.85,53.31,77.82,58.67,86.09,6h.41c0-3.01,0-8.99,0-12h-.41c-.01-.08-.03-.16-.04-.24Zm-24.49,7.28c-1.28,23.33-36.7,22.31-36.69-1.04.48-24.81,37.66-23.76,36.69,1.04Z",
    style: {
      fill: "url(#save-as-image_svg__ds)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.38,216.55l-33.55-57.64c-2.22-3.81-6.34-6.18-10.75-6.18-4.41,0-8.53,2.37-10.75,6.19l-106.18,182.58c-.21.36-.4.73-.57,1.11-.04.09-.07.19-.11.28-.12.28-.24.57-.34.86-.04.1-.06.21-.09.31-.09.29-.18.57-.24.87-.02.09-.04.19-.05.28-.06.3-.12.61-.16.92-.01.08-.01.16-.02.24-.04.32-.06.64-.07.97,0,.07,0,.14,0,.21,0,.33,0,.66.02.99,0,.07.01.14.02.21.03.33.06.65.11.97.01.08.03.15.04.23.04.24.08.47.13.71l1.1,4.6h1.07c.97,1.28,2.2,2.4,3.67,3.26,1.92,1.12,4.06,1.69,6.23,1.69,1.07,0,2.14-.14,3.2-.42,2.73-.72,5.07-2.31,6.74-4.53h.11l96.15-165.34,27.38,47.03c4.59-7.63,10.31-14.5,16.92-20.39Z",
    style: {
      fill: "url(#save-as-image_svg__dt)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.73,71.95c-2.32-2.32-5.52-3.64-8.8-3.64H54.06c-3.27,0-6.48,1.33-8.8,3.64s-3.64,5.52-3.64,8.8v268.5c0,3.28,1.33,6.48,3.64,8.8,2.32,2.32,5.52,3.64,8.8,3.64h169.08c6.9,0,12.5-5.6,12.5-12.5s-5.6-12.5-12.5-12.5h-47c-.56,0-1.1.05-1.64.12h-108.01V93.19h296.99v86.67c-.07.54-.12,1.08-.12,1.64v29c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5V80.75c0-3.28-1.33-6.48-3.64-8.8Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.29,256v32.94h-16.28v-32.94h16.28Zm40.71,14.88v110.94h-125.83v-125.83h31.09v39.23h63.65v-39.23h14.16l16.92,14.88Zm-22.57,51.94c0-3.79-3.56-6.87-7.94-6.87h-64.8c-4.38,0-7.94,3.08-7.94,6.87v37.82h80.68v-37.82Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAsImage);
export default __webpack_public_path__ + "static/media/save-as-image.a5306c1671b383a8a91b8a3bb68c7976.svg";
export { ForwardRef as ReactComponent };